module.exports = __webpack_public_path__ + "static/AXS-39075a20510a7d382a95a7efaec4a90d.svg";